namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_image, {

		userSelect: 'none',

		Image: {
			width: '100%',
			height: '100%',
			transition: 'none',
			pointerEvents: 'none',
			objectFit: 'contain',
		},

		Content_scroll: {
			overflow: 'hidden',
		},

	} )

}
